class KossoTheme {
  constructor() {
    this.drawer = document.querySelector('[data-mobile-drawer]');
    this.lastFocus = null;
    this.bind();
    this.initProductForms(document);
    this.initGalleries(document);
    this.syncGiftTiers();
  }

  bind() {
    document.addEventListener('click', (event) => {
      const modalTrigger = event.target.closest('[data-modal-open]');
      if (modalTrigger) return this.openModal(modalTrigger);
      const modalClose = event.target.closest('[data-modal-close]');
      if (modalClose) return this.closeModal(modalClose);
      if (event.target.matches('dialog.site-modal')) return event.target.close();
      const menuToggle = event.target.closest('[data-menu-toggle]');
      if (menuToggle) return this.toggleMenu(menuToggle);
      if (event.target.closest('[data-drawer-close]')) return this.closeMenu();
      const removeOfferGroup = event.target.closest('[data-gos-remove-offer-group]');
      if (removeOfferGroup) return this.removeQuantityOfferGroup(event, removeOfferGroup);
      const qtyButton = event.target.closest('[data-quantity-change]');
      if (qtyButton) return this.changeQuantity(qtyButton);
      const facetToggle = event.target.closest('[data-facet-toggle]');
      if (facetToggle) return document.querySelector('[data-facets]')?.classList.toggle('is-open');
      if (event.target.closest('[data-scroll-to-product]')) {
        document.querySelector('[data-product-form]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });

    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') this.closeMenu(); });
    document.addEventListener('input', (event) => {
      if (!event.target.matches('.cart-lines input[name="updates[]"]:not([type="hidden"])')) return;
      const checkout = document.querySelector('[data-gos-checkout]'); const status = document.querySelector('[data-gos-gift-status]');
      if (checkout) checkout.disabled = true;
      if (status) status.textContent = 'Werk eerst je winkelwagen bij. Daarna worden de cumulatieve cadeaus opnieuw gecontroleerd.';
    });
    document.addEventListener('change', (event) => {
      if (event.target.matches('[data-auto-submit]')) event.target.form?.submit();
      if (event.target.matches('[data-option-input]')) this.updateVariant(event.target.closest('[data-product-root]'));
      if (event.target.matches('[data-gos-quantity-radio]')) this.updateQuantityOffer(event.target.closest('[data-product-root]'));
      if (event.target.matches('[data-gos-mix-variant]')) this.updateQuantityMixState(event.target.closest('[data-product-root]'));
      if (event.target.matches('.cart-lines input[name="updates[]"]:not([type="hidden"])')) {
        const checkout = document.querySelector('[data-gos-checkout]'); const status = document.querySelector('[data-gos-gift-status]');
        if (checkout) checkout.disabled = true;
        if (status) status.textContent = 'Werk eerst je winkelwagen bij. Daarna worden de cumulatieve cadeaus opnieuw gecontroleerd.';
      }
    });
    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-product-form]');
      if (form && window.fetch) this.ajaxAdd(event, form);
    });
    document.addEventListener('shopify:section:load', (event) => {
      this.initProductForms(event.target); this.initGalleries(event.target); this.syncGiftTiers();
    });
  }

  money(cents) {
    const amount = Number(cents);
    const safeCents = Number.isFinite(amount) ? Math.round(amount) : 0;
    const formatted = (safeCents / 100).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return `${formatted} €`;
  }

  toggleMenu(button) {
    const open = !this.drawer?.classList.contains('is-open');
    this.lastFocus = button; this.drawer?.classList.toggle('is-open', open);
    button.setAttribute('aria-expanded', String(open)); document.body.style.overflow = open ? 'hidden' : '';
    if (open) this.drawer?.querySelector('button, a')?.focus();
  }
  closeMenu() {
    if (!this.drawer?.classList.contains('is-open')) return;
    this.drawer.classList.remove('is-open'); document.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = ''; this.lastFocus?.focus();
  }

  openModal(trigger) {
    const dialog = document.getElementById(trigger.dataset.modalOpen); if (!dialog?.showModal) return;
    this.closeMenu(); dialog._trigger = trigger; trigger.setAttribute('aria-expanded', 'true'); dialog.showModal();
    document.body.classList.add('modal-open'); dialog.querySelector('[data-modal-close]')?.focus();
    if (dialog.dataset.modalBound) return; dialog.dataset.modalBound = 'true';
    dialog.addEventListener('close', () => {
      document.body.classList.remove('modal-open'); dialog._trigger?.setAttribute('aria-expanded', 'false'); dialog._trigger?.focus();
    });
  }
  closeModal(button) { button.closest('dialog')?.close(); }
  changeQuantity(button) {
    if (button.closest('[data-product-root]')?.classList.contains('has-gos-quantity-offer')) return;
    const input = button.parentElement.querySelector('input[type="number"]'); if (!input) return;
    input.value = Math.max(Number(input.min || 1), Math.min(Number(input.max || 999), Number(input.value || 1) + Number(button.dataset.quantityChange)));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  readJson(root, selector) {
    const node = root?.querySelector(selector);
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (_) { return null; }
  }

  initProductForms(scope) {
    scope.querySelectorAll('[data-product-root]').forEach((root) => {
      root._gosBundle = this.readJson(root, '[data-gos-bundle-config]');
      root._gosQuantity = this.readJson(root, '[data-gos-quantity-offer-config]');
      this.updateVariant(root);
    });
  }

  updateVariant(root) {
    if (!root) return;
    const data = root.querySelector('[data-product-json]'); if (!data) return;
    let product; try { product = JSON.parse(data.textContent); } catch (_) { return; }
    root._gosProduct = product;
    const selected = [...root.querySelectorAll('[data-option-input]:checked')].map((input) => input.value);
    const variant = product.variants.find((candidate) => candidate.options.every((option, index) => option === selected[index])) || product.variants[0];
    const idInput = root.querySelector('[name="id"]'); const addButton = root.querySelector('[name="add"]');
    if (!variant) return;
    if (idInput) idInput.value = variant.id;
    root._gosSelectedVariant = variant;
    root._gosResolvedBundleItems = this.resolveBundleItems(root._gosBundle, variant, product);
    const expectsBundle = root.dataset.gosBundleParent === 'true';
    const bundleReady = !expectsBundle || (root._gosBundle?.ready && root._gosResolvedBundleItems.length > 0 && root._gosResolvedBundleItems.every((item) => Number(item.variantId) > 0 && Number(item.quantity) > 0 && item.available));
    if (addButton) {
      addButton.disabled = expectsBundle ? !bundleReady : !variant.available;
      addButton.querySelector('span').textContent = (expectsBundle ? bundleReady : variant.available) ? 'IN WINKELWAGEN' : (expectsBundle ? 'PAKKET NIET BESCHIKBAAR' : addButton.dataset.soldOut);
    }
    const configuredBundlePrice = Number(root._gosBundle?.totalCents);
    const visiblePrice = root._gosBundle && configuredBundlePrice > 0 ? configuredBundlePrice : variant.price;
    const price = root.querySelector('[data-product-price]'); if (price) price.textContent = this.money(visiblePrice);
    const mediaId = variant.featured_media?.id; if (mediaId) root.querySelector(`[data-media-id="${mediaId}"]`)?.click();
    root.dataset.currentPrice = variant.price;
    this.renderBundleSummary(root);
    this.renderQuantityOffers(root, variant);
    if (history.replaceState) history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
  }

  normaliseOption(value) { return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLocaleLowerCase('nl-NL').replace(/[^a-z0-9]+/g, ''); }

  flavourOptionIndex(optionNames) {
    const flavourTerms = ['smaak', 'smaken', 'flavour', 'flavor', 'geschmack', 'sabor', 'gout', 'aroma', 'taste'];
    return (optionNames || []).findIndex((name) => flavourTerms.some((term) => this.normaliseOption(name?.name || name).includes(term)));
  }

  quantityCompatibilityKey(product, variant) {
    const optionNames = (product?.options || []).map((option) => option?.name || option);
    const flavourIndex = this.flavourOptionIndex(optionNames);
    const parts = optionNames.map((name, index) => index === flavourIndex ? null : `${this.normaliseOption(name)}=${this.normaliseOption(variant?.options?.[index])}`).filter(Boolean);
    return parts.join('|') || 'flavour-only';
  }

  cartLineCompatibilityKey(line) {
    const values = Array.isArray(line?.options_with_values) ? line.options_with_values : [];
    const flavourIndex = this.flavourOptionIndex(values.map((option) => option?.name));
    const parts = values.map((option, index) => index === flavourIndex ? null : `${this.normaliseOption(option?.name)}=${this.normaliseOption(option?.value)}`).filter(Boolean);
    return parts.join('|') || 'flavour-only';
  }

  resolveBundleItems(config, parentVariant, parentProduct) {
    if (!config?.ready || !Array.isArray(config.items)) return [];
    return config.items.map((item) => {
      if (!item.matchParentVariant) return { ...item };
      const parentFlavourIndex = this.flavourOptionIndex(parentProduct?.options);
      const componentFlavourIndex = this.flavourOptionIndex(item.optionNames);
      const fallbackParentOption = (parentVariant?.options || []).find((option) => this.normaliseOption(option) && this.normaliseOption(option) !== 'defaulttitle');
      const parentFlavour = this.normaliseOption(parentVariant?.options?.[parentFlavourIndex >= 0 ? parentFlavourIndex : 0] || fallbackParentOption);
      const match = (item.variants || []).find((candidate) => {
        if (!parentFlavour) return false;
        const candidateFlavour = this.normaliseOption(candidate.options?.[componentFlavourIndex >= 0 ? componentFlavourIndex : 0]);
        return candidateFlavour === parentFlavour;
      });
      return { ...item, ...(match || { variantId: 0, available: false }), variantTitle: match?.title || '' };
    });
  }

  renderBundleSummary(root) {
    const config = root._gosBundle;
    if (!config) return;
    const pending = root.querySelector('[data-gos-bundle-pending]');
    const summary = root.querySelector('[data-gos-bundle-summary]');
    const items = root._gosResolvedBundleItems || [];
    const validItems = config.ready && items.length > 0 && items.every((item) => Number(item.variantId) > 0 && Number(item.quantity) > 0 && item.available);
    if (!validItems) { if (pending) pending.hidden = false; if (summary) summary.hidden = true; return; }
    if (pending) pending.hidden = true;
    const list = root.querySelector('[data-gos-bundle-items]');
    if (!summary || !list) return;
    root.querySelector('[data-gos-bundle-title]').textContent = config.title;
    list.replaceChildren(...items.map((item) => {
      const row = document.createElement('div'); row.className = 'gos-bundle-component';
      if (item.image) { const image = document.createElement('img'); image.src = item.image; image.alt = ''; image.loading = 'lazy'; row.append(image); }
      const copy = document.createElement('div'); const title = document.createElement('strong'); const amount = document.createElement('span');
      title.textContent = item.title; amount.textContent = `${item.quantity} × ${this.money(item.price)}${item.variantTitle && !/^default title$/i.test(String(item.variantTitle).trim()) ? ` · ${item.variantTitle}` : ''}`; copy.append(title, amount); row.append(copy); return row;
    }));
    summary.hidden = false;
  }

  renderQuantityOffers(root, variant) {
    const config = root._gosQuantity; const holder = root.querySelector('[data-gos-quantity-offer]'); const list = root.querySelector('[data-gos-quantity-options]');
    if (!config || !holder || !list) return;
    const allowed = new Set((config.allowedUnitPrices || []).map(Number));
    const offers = (config.offersByBase?.[String(variant.price)] || []).filter((offer) => Number(offer.quantity) > 1 && allowed.has(Number(offer.checkoutUnitCents)) && Number(offer.checkoutTotalCents) === Number(offer.quantity) * Number(offer.checkoutUnitCents));
    if (!config.ready || offers.length === 0) {
      holder.hidden = true; root.classList.remove('has-gos-quantity-offer');
      this.renderQuantityMix(root, 1);
      const quantity = root.querySelector('[data-product-quantity]'); const label = root.querySelector('[data-add-label]');
      if (quantity) { quantity.value = 1; quantity.readOnly = false; }
      if (label) label.textContent = variant.available ? 'IN WINKELWAGEN' : (root.querySelector('[name="add"]')?.dataset.soldOut || 'UITVERKOCHT');
      return;
    }
    const rows = [{ quantity: 1, checkoutUnitCents: Number(variant.price), checkoutTotalCents: Number(variant.price), regular: true }, ...offers];
    const presentation = ['months', 'boxes', 'packages'].includes(config.presentation) ? config.presentation : 'packages';
    const quantityLabel = (quantity) => {
      if (presentation === 'months') return `${quantity} ${quantity === 1 ? 'MAAND' : 'MAANDEN'} VOORRAAD`;
      if (presentation === 'boxes') return `${quantity} ${quantity === 1 ? 'DOOS' : 'DOZEN'}`;
      return `${quantity} ${quantity === 1 ? 'VERPAKKING' : 'VERPAKKINGEN'}`;
    };
    const q2Unit = Number(rows.find((offer) => offer.quantity === 2)?.checkoutUnitCents || 0);
    list.innerHTML = rows.map((offer) => {
      const regularTotal = Number(variant.price) * Number(offer.quantity); const saving = regularTotal - Number(offer.checkoutTotalCents); const discount = offer.regular ? 0 : (saving / regularTotal) * 100;
      const isProgressiveBest = offer.quantity === 3 && Number(offer.checkoutUnitCents) < q2Unit;
      const badge = offer.quantity === 2 ? '<span class="bundle-option__badge">POPULAIR</span>' : isProgressiveBest ? '<span class="bundle-option__badge">BESTE KEUZE</span>' : '';
      const detail = offer.regular ? 'Normale prijs' : `${discount.toLocaleString('nl-NL', { minimumFractionDigits: 1, maximumFractionDigits: 1 })}% korting · bespaar ${this.money(saving)}`;
      const regularPrice = offer.regular ? '' : `<del>${this.money(regularTotal)}</del>`;
      const contents = presentation === 'boxes' && config.boxContents ? `<small>${offer.quantity * 12} ${config.boxContents}</small>` : '';
      return `<label class="bundle-option${isProgressiveBest ? ' bundle-option--best' : ''}">${badge}<input type="radio" name="gos_quantity_offer" value="${offer.quantity}" data-gos-quantity-radio data-checkout-unit="${offer.checkoutUnitCents}"${offer.quantity === 1 ? ' checked' : ''}><span class="bundle-option__radio"></span><span class="bundle-option__copy"><strong>${quantityLabel(offer.quantity)}</strong>${contents}<small>${detail}</small></span><span class="bundle-option__price">${regularPrice}<strong>${this.money(offer.checkoutTotalCents)}</strong><small>${this.money(offer.checkoutUnitCents)} per stuk</small></span></label>`;
    }).join('');
    holder.hidden = false; root.classList.add('has-gos-quantity-offer'); this.updateQuantityOffer(root);
  }

  updateQuantityOffer(root) {
    const selected = root?.querySelector('[data-gos-quantity-radio]:checked'); if (!selected) return;
    root.querySelectorAll('[data-gos-quantity-radio]').forEach((radio) => radio.closest('.bundle-option')?.classList.toggle('is-selected', radio === selected));
    const qty = Number(selected.value); const quantity = root.querySelector('[data-product-quantity]'); const label = root.querySelector('[data-add-label]');
    if (quantity) { quantity.value = qty; quantity.readOnly = true; }
    this.renderQuantityMix(root, qty);
    if (label) {
      const presentation = root._gosQuantity?.presentation;
      const plural = presentation === 'boxes' ? 'DOZEN' : presentation === 'months' ? 'MAANDEN VOORRAAD' : 'VERPAKKINGEN';
      label.textContent = root._gosSelectedVariant?.available === false ? (root.querySelector('[name="add"]')?.dataset.soldOut || 'UITVERKOCHT') : (qty === 1 ? 'IN WINKELWAGEN' : `VOEG ${qty} ${plural} TOE`);
    }
  }

  compatibleQuantityVariants(root) {
    const product = root?._gosProduct; const selected = root?._gosSelectedVariant;
    if (!product || !selected) return [];
    const optionNames = Array.isArray(product.options) ? product.options.map((option) => option?.name || option) : [];
    const flavourIndex = this.flavourOptionIndex(optionNames);
    const samePrice = (product.variants || []).filter((variant) => variant.available && Number(variant.price) === Number(selected.price));
    let candidates = samePrice;
    if (flavourIndex >= 0) {
      candidates = samePrice.filter((variant) => variant.options.every((option, index) => index === flavourIndex || option === selected.options[index]));
    } else {
      candidates = samePrice.filter((variant) => variant.id === selected.id);
    }
    if (!candidates.some((variant) => Number(variant.id) === Number(selected.id)) && selected.available) candidates.unshift(selected);
    return candidates.map((variant) => ({ ...variant, gosChoiceLabel: product.variants.length === 1 || /^default title$/i.test(String(variant.title || '').trim()) ? product.title : (flavourIndex >= 0 ? variant.options[flavourIndex] : variant.title) }));
  }

  renderQuantityMix(root, quantity) {
    const holder = root?.querySelector('[data-gos-quantity-mix]'); const rows = root?.querySelector('[data-gos-quantity-mix-rows]');
    if (!holder || !rows) return;
    const qty = Number(quantity);
    if (!Number.isInteger(qty) || qty <= 1) { holder.hidden = true; rows.replaceChildren(); return; }
    const candidates = this.compatibleQuantityVariants(root);
    if (!candidates.length) { holder.hidden = true; rows.replaceChildren(); return; }
    const selectedId = Number(root._gosSelectedVariant?.id || 0);
    rows.replaceChildren(...Array.from({ length: qty }, (_, index) => {
      const row = document.createElement('label'); row.className = 'gos-quantity-mix__row';
      const label = document.createElement('span'); label.textContent = `Verpakking ${index + 1}`;
      const select = document.createElement('select'); select.dataset.gosMixVariant = ''; select.setAttribute('aria-label', `Smaak of optie voor verpakking ${index + 1}`);
      candidates.forEach((variant) => {
        const option = document.createElement('option'); option.value = String(variant.id); option.textContent = variant.gosChoiceLabel || variant.title || `Variant ${variant.id}`;
        option.selected = Number(variant.id) === selectedId; select.append(option);
      });
      if (candidates.length === 1) select.setAttribute('aria-readonly', 'true');
      row.append(label, select); return row;
    }));
    const note = root.querySelector('[data-gos-quantity-mix-note]');
    if (note) note.textContent = candidates.length > 1 ? 'Combineer beschikbare smaken; formaat en basisprijs blijven gelijk.' : 'Deze verpakking heeft één beschikbare optie. Elk stuk wordt toch afzonderlijk toegevoegd.';
    holder.hidden = false;
    this.updateQuantityMixState(root);
  }

  updateQuantityMixState(root) {
    const button = root?.querySelector('[name="add"]'); const qty = Number(root?.querySelector('[data-gos-quantity-radio]:checked')?.value || 1);
    if (!button || qty <= 1) return;
    const valid = root._gosSelectedVariant?.available !== false && root.querySelectorAll('[data-gos-mix-variant]').length === qty && this.selectedQuantityVariants(root, qty).length === qty;
    button.disabled = !valid;
    const label = root.querySelector('[data-add-label]');
    if (label && !valid) label.textContent = 'KIES ALLE OPTIES';
    else if (label) {
      const presentation = root._gosQuantity?.presentation;
      const plural = presentation === 'boxes' ? 'DOZEN' : presentation === 'months' ? 'MAANDEN VOORRAAD' : 'VERPAKKINGEN';
      label.textContent = `VOEG ${qty} ${plural} TOE`;
    }
  }

  selectedQuantityVariants(root, quantity) {
    const qty = Number(quantity); const candidates = this.compatibleQuantityVariants(root); const allowed = new Map(candidates.map((variant) => [Number(variant.id), variant]));
    const ids = [...(root?.querySelectorAll('[data-gos-mix-variant]') || [])].map((select) => Number(select.value));
    if (ids.length !== qty || ids.some((id) => !allowed.has(id))) return [];
    return ids.map((id) => allowed.get(id));
  }

  initGalleries(scope) {
    scope.querySelectorAll('[data-gallery]').forEach((gallery) => gallery.querySelectorAll('[data-media-id]').forEach((thumb) => thumb.addEventListener('click', () => {
      const image = gallery.querySelector('[data-gallery-main]'); if (!image) return;
      image.src = thumb.dataset.mediaSrc; image.srcset = thumb.dataset.mediaSrcset || ''; image.alt = thumb.dataset.mediaAlt || '';
      gallery.querySelectorAll('[data-media-id]').forEach((item) => item.setAttribute('aria-current', 'false')); thumb.setAttribute('aria-current', 'true');
    })));
  }

  async ajaxAdd(event, form) {
    event.preventDefault(); const button = form.querySelector('[name="add"]'); const live = document.getElementById('LiveRegion'); button?.setAttribute('aria-busy', 'true');
    try {
      const rootNode = form.closest('[data-product-root]'); const bundle = rootNode?._gosBundle; const quantityConfig = rootNode?._gosQuantity; const expectsBundle = rootNode?.dataset.gosBundleParent === 'true';
      const qty = Math.max(1, Number(form.querySelector('[name="quantity"]')?.value || 1));
      if (!expectsBundle && quantityConfig?.ready) {
        const productId = Number(rootNode?._gosProduct?.id || 0); const cartRoot = window.Shopify?.routes?.root || '/';
        const existingCart = await fetch(`${cartRoot}cart.js`).then((response) => response.json());
        if ((existingCart.items || []).some((line) => (Number(line.product_id) === productId || line.properties?._GOS_source_handle === rootNode._gosProduct.handle))) {
          throw new Error('Dit product staat al in je winkelwagen. Verwijder de bestaande regel of voorraaddeal voordat je een nieuwe keuze toevoegt.');
        }
      }
      let options;
      let addedCount = qty;
      if (expectsBundle) {
        const resolvedItems = rootNode?._gosResolvedBundleItems || [];
        if (!bundle?.ready || !resolvedItems.length || resolvedItems.some((item) => Number(item.variantId) <= 0 || !item.available)) throw new Error('Dit pakket is nog niet beschikbaar. Probeer het later opnieuw.');
        const randomPart = globalThis.crypto?.randomUUID ? globalThis.crypto.randomUUID() : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
        const groupId = `bundle-${randomPart}`; const items = []; let slot = 0;
        resolvedItems.forEach((item) => {
          const count = Number(item.quantity) * qty;
          for (let index = 0; index < count; index += 1) {
            slot += 1;
            items.push({ id: Number(item.variantId), quantity: 1, properties: { Pakket: bundle.title, '_GOS_bundle_parent': bundle.parentHandle, '_GOS_bundle_group': groupId, '_GOS_bundle_slot': String(slot) } });
          }
        });
        addedCount = items.length;
        items.forEach((item) => { item.properties._GOS_bundle_size = String(addedCount); });
        options = { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) };
      } else {
        const selectedOffer = form.querySelector('[data-gos-quantity-radio]:checked'); const offerQty = Number(selectedOffer?.value || 1); const configuredUnit = Number(selectedOffer?.dataset.checkoutUnit || 0);
        const allowed = new Set((quantityConfig?.allowedUnitPrices || []).map(Number));
        if (quantityConfig?.ready && selectedOffer && offerQty > 1 && allowed.has(configuredUnit)) {
          const basePrice = Number(rootNode?._gosSelectedVariant?.price || 0); const expectedUnit = this.checkoutUnitFor(basePrice, offerQty);
          if (expectedUnit !== configuredUnit) throw new Error('Deze voorraaddeal kon niet veilig worden geverifieerd. Vernieuw de pagina en probeer opnieuw.');
          const selectedVariants = this.selectedQuantityVariants(rootNode, offerQty);
          if (selectedVariants.length !== offerQty) throw new Error('Kies voor iedere verpakking een beschikbare smaak of optie.');
          addedCount = offerQty;
          const randomPart = globalThis.crypto?.randomUUID ? globalThis.crypto.randomUUID() : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
          const groupId = `gos-${randomPart}`; const productId = Number(rootNode?._gosProduct?.id || 0);
          const compatibilityKey = this.quantityCompatibilityKey(rootNode?._gosProduct, rootNode?._gosSelectedVariant);
          const items = await Promise.all(selectedVariants.map(async (variant, index) => {
            const sourceOptions = JSON.stringify(variant.options);
            const offer = window.KossoPricedOffers?.[rootNode._gosProduct.handle]?.[sourceOptions]?.[String(offerQty)];
            const handle = offer?.handles?.[index];
            if (!handle || offer.base !== basePrice || offer.unit !== configuredUnit) throw new Error('Deze voorraaddeal is nog niet geconfigureerd. Neem contact met ons op.');
            const response = await fetch((window.Shopify?.routes?.root || '/') + 'products/' + encodeURIComponent(handle) + '.js');
            if (!response.ok) throw new Error('Deze voorraaddeal is nog niet beschikbaar. Probeer later opnieuw.');
            const technical = await response.json();
            const priced = technical.variants?.find((item) => item.available && Number(item.price) === configuredUnit);
            if (!priced || technical.handle !== handle) throw new Error('De actieprijs is niet beschikbaar. De voorraaddeal is niet toegevoegd.');
            return { id: Number(priced.id), quantity: 1, properties: {
              Voorraaddeal: 'Verpakking ' + (index + 1) + ' van ' + offerQty,
              '_GOS_priced_offer': 'true', '_GOS_priced_group': groupId,
              '_GOS_priced_size': String(offerQty), '_GOS_priced_slot': String(index + 1),
              '_GOS_source_handle': rootNode._gosProduct.handle, '_GOS_source_options': sourceOptions
            }};
          }));
          options = { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) };
        } else {
          const id = Number(form.querySelector('[name="id"]')?.value || 0);
          if (!id) throw new Error('Dit product kon niet veilig worden toegevoegd. Vernieuw de pagina en probeer opnieuw.');
          const randomPart = globalThis.crypto?.randomUUID ? globalThis.crypto.randomUUID() : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
          const groupId = `line-${randomPart}`;
          const items = Array.from({ length: qty }, (_, index) => ({ id, quantity: 1, properties: { '_GOS_split_line': 'true', '_GOS_split_group': groupId, '_GOS_split_size': String(qty), '_GOS_split_slot': String(index + 1) } }));
          options = { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) };
        }
      }
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, options); const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message);
      const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((res) => res.json());
      document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
      if (live) live.textContent = `${addedCount} product${addedCount > 1 ? 'en' : ''} toegevoegd aan je winkelwagen.`;
      window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
    } catch (error) { if (live) live.textContent = error.message; const box = form.querySelector('[data-product-error]'); if (box) { box.hidden = false; box.textContent = error.message; } }
    finally { button?.removeAttribute('aria-busy'); }
  }

  checkoutUnitFor(basePrice, quantity) {
    const grid = {
      4499: { q2: 3499, q3: 2999 }, 3999: { q2: 2999, q3: 2499 },
      3499: { q2: 2999, q3: 2499 }, 2999: { q2: 2499, q3: 1999 },
      2499: { q2: 1999, q3: 1999 }
    };
    const base = Number(basePrice); const rule = grid[base]; const qty = Number(quantity);
    if (!Number.isInteger(qty) || qty < 1 || !Number.isInteger(base) || base <= 0) return null;
    if (qty === 1) return base;
    if (!rule) return null;
    if (qty === 3) return rule.q3;
    if (qty === 2) return rule.q2;
    return null;
  }

  quantityOfferGroupPricing(cart, eligibleVariantIds) {
    const groups = new Map(); const invalidLines = [];
    for (const line of cart.items || []) {
      const properties = line.properties || {};
      const marked = Boolean(properties._GOS_quantity_offer || properties._GOS_offer_group || properties._GOS_checkout_unit_cents);
      if (!marked) continue;
      const groupId = String(properties._GOS_offer_group || '').trim();
      if (!groupId) { invalidLines.push(line); continue; }
      if (!groups.has(groupId)) groups.set(groupId, []);
      groups.get(groupId).push(line);
    }

    const lineUnits = new Map();
    for (const [groupId, lines] of groups) {
      const firstProperties = lines[0]?.properties || {};
      const size = Number(firstProperties._GOS_offer_size); const basePrice = Number(firstProperties._GOS_offer_base_cents);
      const productId = Number(firstProperties._GOS_offer_product_id); const expectedUnit = this.checkoutUnitFor(basePrice, size);
      const compatibilityKey = String(firstProperties._GOS_offer_compat_key || '');
      const slots = new Set();
      let valid = (size === 2 || size === 3) && lines.length === size && Number.isInteger(productId) && productId > 0 && compatibilityKey.length > 0 && Number.isInteger(expectedUnit) && expectedUnit > 0;
      for (const line of lines) {
        const properties = line.properties || {}; const slot = Number(properties._GOS_offer_slot);
        slots.add(slot);
        valid = valid
          && properties._GOS_quantity_offer === 'true'
          && String(properties._GOS_offer_group || '') === groupId
          && Number(properties._GOS_offer_size) === size
          && Number(properties._GOS_offer_base_cents) === basePrice
          && Number(properties._GOS_offer_product_id) === productId
          && String(properties._GOS_offer_compat_key || '') === compatibilityKey
          && this.cartLineCompatibilityKey(line) === compatibilityKey
          && Number(line.product_id) === productId
          && Number(line.original_price) === basePrice
          && Number(line.quantity) === 1
          && Number.isInteger(slot) && slot >= 1 && slot <= size
          && eligibleVariantIds.has(Number(line.variant_id));
      }
      const sameProductLines = (cart.items || []).filter((line) => Number(line.product_id) === productId && !line.properties?._GOS_free_gift);
      valid = valid && sameProductLines.length === size && sameProductLines.every((line) => String(line.properties?._GOS_priced_group || line.properties?._GOS_offer_group || '') === groupId);
      valid = valid && slots.size === size;
      if (!valid) { invalidLines.push(...lines); continue; }
      lines.forEach((line) => lineUnits.set(line.key, expectedUnit));
    }
    return { lineUnits, invalidLines };
  }

  validatePricedOffers(cart) {
    const groups = new Map();
    for (const line of cart.items || []) {
      const props = line.properties || {};
      if (props._GOS_priced_offer !== 'true') continue;
      const group = String(props._GOS_priced_group || '');
      if (!group) throw new Error('De voorraaddeal is onvolledig. Voeg de deal opnieuw toe.');
      if (!groups.has(group)) groups.set(group, []);
      groups.get(group).push(line);
    }
    for (const lines of groups.values()) {
      const first = lines[0].properties;
      const size = Number(first._GOS_priced_size); const slots = new Set();
      if (![2, 3].includes(size) || lines.length !== size) throw new Error('De voorraaddeal is onvolledig. Voeg de deal opnieuw toe.');
      for (const line of lines) {
        const props = line.properties; const slot = Number(props._GOS_priced_slot);
        const offer = window.KossoPricedOffers?.[props._GOS_source_handle]?.[props._GOS_source_options]?.[String(size)];
        if (!offer || props._GOS_source_handle !== first._GOS_source_handle || Number(props._GOS_priced_size) !== size
          || !Number.isInteger(slot) || slot < 1 || slot > size || slots.has(slot)
          || offer.handles[slot - 1] !== line.handle || Number(line.quantity) !== 1 || Number(line.original_price) !== offer.unit) {
          throw new Error('De voorraaddeal is gewijzigd. Verwijder de deal en voeg hem opnieuw toe.');
        }
        slots.add(slot);
      }
    }
  }

  async normaliseQuantityOfferLine(root, cart, eligibleVariantIds) {
    this.validatePricedOffers(cart);
    const mergedLine = (cart.items || []).find((line) => Number(line.quantity) !== 1);
    if (mergedLine) {
      throw new Error('Afrekenen is geblokkeerd: elk artikel moet als een afzonderlijke regel met aantal 1 in de winkelwagen staan. Verwijder de samengevoegde regel en voeg het product opnieuw toe.');
    }
    const pricing = this.quantityOfferGroupPricing(cart, eligibleVariantIds);
    if (pricing.invalidLines.length) {
      throw new Error('Afrekenen is geblokkeerd: een voorraaddeal is niet verdeeld over afzonderlijke regels met aantal 1. Verwijder die deal en voeg hem opnieuw toe.');
    }
    for (const line of cart.items || []) {
      const properties = { ...(line.properties || {}) };
      if (!pricing.lineUnits.has(line.key)) continue;
      delete properties.Aanbieding; delete properties._GOS_checkout_unit_cents; delete properties['_CheckoutFlow rule'];
      properties._GOS_quantity_offer = 'true';
      properties.Voorraaddeal = `Verpakking ${properties._GOS_offer_slot} van ${properties._GOS_offer_size}`;
      const current = line.properties || {};
      if (JSON.stringify(Object.entries(current).sort()) === JSON.stringify(Object.entries(properties).sort())) continue;
      const response = await fetch(`${root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: line.key, quantity: 1, properties }) });
      if (!response.ok) throw new Error('Afrekenen is tijdelijk geblokkeerd: de hoeveelheidsprijs kon niet worden bijgewerkt.');
      return true;
    }
    return false;
  }

  async removeQuantityOfferGroup(event, button) {
    event.preventDefault(); const groupId = String(button.dataset.gosRemoveOfferGroup || '').trim();
    if (!groupId) { window.location.assign(button.href); return; }
    button.setAttribute('aria-busy', 'true');
    try {
      const root = window.Shopify?.routes?.root || '/'; const cart = await fetch(`${root}cart.js`).then((response) => response.json()); const updates = {};
      (cart.items || []).filter((line) => String(line.properties?._GOS_priced_group || line.properties?._GOS_offer_group || '') === groupId).forEach((line) => { updates[line.key] = 0; });
      if (!Object.keys(updates).length) { window.location.assign(button.href); return; }
      const response = await fetch(`${root}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates }) });
      if (!response.ok) throw new Error('De voorraaddeal kon niet worden verwijderd.');
      window.location.reload();
    } catch (error) {
      button.removeAttribute('aria-busy'); const status = document.querySelector('[data-gos-gift-status]'); if (status) status.textContent = error.message;
    }
  }

  async syncGiftTiers() {
    const holder = document.querySelector('[data-gos-gift-progress]'); if (!holder || holder.dataset.syncing === 'true') return;
    const checkout = document.querySelector('[data-gos-checkout]'); const status = holder.querySelector('[data-gos-gift-status]');
    const config = this.readJson(holder, '[data-gos-gift-config]');
    const gifts = (config?.gifts || []).map((gift) => ({ ...gift, variantId: Number(gift.variantId), threshold: Number(gift.threshold), price: Number(gift.price) }));
    const eligibleVariantIds = new Set((config?.quantityOfferVariantIds || []).map(Number).filter((id) => id > 0));
    const originalStatus = status?.textContent || '';
    let syncComplete = false; let reloadPending = false;
    holder.dataset.syncing = 'true'; if (checkout) { checkout.disabled = true; checkout.setAttribute('aria-busy', 'true'); }
    if (status) status.textContent = 'Je cumulatieve cadeaus worden gecontroleerd…';
    try {
      const root = window.Shopify?.routes?.root || '/'; const cart = await fetch(`${root}cart.js`).then((r) => r.json());
      const quantityOfferChanged = await this.normaliseQuantityOfferLine(root, cart, eligibleVariantIds);
      if (quantityOfferChanged) {
        reloadPending = true;
        if (status) status.textContent = 'Je hoeveelheidsprijs en cumulatieve cadeaus worden bijgewerkt…';
        window.location.reload(); return;
      }
      const giftIds = new Set(gifts.filter((gift) => gift.variantId > 0).map((gift) => gift.variantId));
      const offerPricing = this.quantityOfferGroupPricing(cart, eligibleVariantIds);
      if (offerPricing.invalidLines.length) throw new Error('Afrekenen is geblokkeerd: iedere voorraaddeal moet uit losse regels met aantal 1 bestaan. Verwijder de deal en voeg hem opnieuw toe.');
      const paidSubtotal = cart.items.filter((item) => !giftIds.has(item.variant_id) && !item.properties?._GOS_free_gift).reduce((sum, item) => {
        const configuredUnit = offerPricing.lineUnits.get(item.key);
        const configuredLine = Number.isInteger(configuredUnit) && configuredUnit > 0 ? configuredUnit : null;
        return sum + (configuredLine ?? Number(item.final_line_price || 0));
      }, 0);
      const expected = gifts.filter((gift) => paidSubtotal >= gift.threshold);
      const invalidExpected = expected.filter((gift) => gift.variantId <= 0 || gift.price !== 0 || !gift.available);
      if (invalidExpected.length) {
        const names = invalidExpected.map((gift) => gift.title || gift.handle).join(', ');
        throw new Error(`Afrekenen is tijdelijk geblokkeerd: het vrijgespeelde cadeau (${names}) is niet beschikbaar of niet correct geconfigureerd.`);
      }
      const desired = new Map(expected.map((gift) => [gift.variantId, gift]));
      const kept = new Set(); const updates = {};
      cart.items.forEach((line) => {
        const giftLine = giftIds.has(line.variant_id) || line.properties?._GOS_free_gift;
        if (!giftLine) return;
        if (!desired.has(line.variant_id) || kept.has(line.variant_id)) updates[line.key] = 0;
        else { kept.add(line.variant_id); if (line.quantity !== 1) updates[line.key] = 1; }
      });
      const missing = [...desired.values()].filter((gift) => !kept.has(gift.variantId));
      if (Object.keys(updates).length) {
        const response = await fetch(`${root}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates }) });
        if (!response.ok) throw new Error('De cadeaus konden niet worden bijgewerkt.');
      }
      if (missing.length) {
        const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: missing.map((gift) => ({ id: gift.variantId, quantity: 1, properties: { '_GOS_free_gift': 'true', '_GOS_gift_threshold': String(gift.threshold) } })) }) });
        if (!response.ok) throw new Error('De cadeaus konden niet worden toegevoegd.');
      }
      if (Object.keys(updates).length || missing.length) {
        reloadPending = true;
        if (status) status.textContent = 'Je cumulatieve cadeaus worden bijgewerkt…';
        window.location.reload(); return;
      }
      syncComplete = kept.size === desired.size && [...desired.keys()].every((variantId) => kept.has(variantId));
      if (!syncComplete) throw new Error('Afrekenen is tijdelijk geblokkeerd omdat de cumulatieve cadeaus niet exact konden worden gecontroleerd.');
      if (status) status.textContent = originalStatus;
    } catch (error) {
      console.warn('Synchronisatie van cadeaus mislukt', error);
      if (status) status.textContent = 'De automatische controle van je winkelwagen is niet voltooid. Controleer je artikelen, prijzen en cadeaus bij het afrekenen.';
    } finally {
      holder.dataset.syncing = 'false';
      if (checkout && !reloadPending) { checkout.disabled = false; checkout.removeAttribute('aria-busy'); }
    }
  }
}

document.addEventListener('DOMContentLoaded', () => new KossoTheme());
